<i18n>
{
	"en": {
		"needAccept": "Need confirmation from driver",
		"title": "Driver"
	},
	"no": {
		"needAccept": "Trenger bekreftelse fra sjåfør",
		"title": "Sjåfør"
	}
}
</i18n>
<template>
	<div>
		<t-combobox-button
			ref="comboboxButton"
			:title="$t('title')"
			icon="person"
			:limit="$options.SERVER_RETURN_LIMIT"

			:searchValue="searchValue"
			:items="filteredItems"
			:selected="value"

			:disabled="disabled"
			disableButtonTabbing

			@focus="onFocus"
			@input="onInput"
			@change="onChange"
			@blur="onBlur"
			@button:click="setShowDialog(true)"
		>
			<template v-slot:optionItemContent="slotProps">
				<div class="item">
					<div class="item-main-text">{{ slotProps.item.name }}</div>
					<div class="item-sub-text">{{ slotProps.item.phoneNumber }}</div>
				</div>
			</template>
		</t-combobox-button>

		<t-after-input v-if="email" :text="email" />
		<t-after-input v-if="phoneNumber" :text="phoneNumber" />
		<t-checkbox
			:label="$t('needAccept')"
			:checked="needAccept"
			@change="$emit('change:needAccept', $event)"
		/>

		<drivers-form-input-dialog
			:items="drivers"
			:isShown="showDialog"
			:initialSearchValue="searchValue"
			icon="person"
			@close="setShowDialog(false)"
			@ok="onChange"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from './store/drivers.store.js';
import formMixin from '@/components/evergreen/inputs/formMixin';
import popoverMixin from '@/components/evergreen/inputs/popoverMixin';
import DriversFormInputDialog from './DriversFormInput/DriversDialog';
import TAfterInput from '@/components/evergreen/timpex/inputs/TAfterInput';
import TComboboxButton from '@/components/evergreen/timpex/inputs/TComboboxButton';
import TCheckbox from '@/components/evergreen/inputs/TCheckbox';

export default {
	name: 'DriverInput',
	components: { TCheckbox, TComboboxButton, TAfterInput, DriversFormInputDialog },
	mixins: [ formMixin, popoverMixin ],
	props: {
		value: Object,
		needAccept: Boolean,
		isInvalid: Boolean,
		validationMessage: String,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			showDialog: false,
			searchValue: '',
			focused: false,
		};
	},
	computed: {
		...mapState(['drivers']),
		email() {
			if (this.value && this.value.email) {
				return this.value.email;
			} else return '';
		},
		phoneNumber() {
			if (this.value && this.value.phoneNumber) {
				return this.value.phoneNumber;
			} else return '';
		},
		filteredItems() {
			return this.drivers.filter( item => {

				if (!item)
					return false;

				let loweredSearchValue = this.searchValue.toLowerCase();

				let ret = true;
				for (let c of loweredSearchValue.split(' ')) {
					ret = ret &&
						( (item.name && item.name.toLowerCase().includes(c))
							|| ( item.phoneNumber && item.phoneNumber.toString().toLowerCase().includes(c) )
						);
				}
				return ret;
			});
		}
	 },
	watch: {
		value: {
			immediate: true,

			handler(value) {
				this.searchValue = this.getSearchValueFromValue(value);
			}
		}
	},
	async created() {
		await this.getDrivers();
	},
	methods: {
		...mapActions(['getDrivers']),
		onFocus() {
			this.focused = true;
		},
		onInput(searchValue) {
			this.searchValue = searchValue;
		},
		onChange(event) {
			this.searchValue = this.getSearchValueFromValue(event);

			this.$emit('change', event);
		},
		onBlur(event) {

			this.focused = false;

			if (!isRelatedTargetButton(event, this.$refs.comboboxButton)) {

				if (this.searchValue === '')
					this.$emit('change', {});

				else
					this.searchValue = this.getSearchValueFromValue(this.value);
			}

			function isRelatedTargetButton(event, comboboxButtonRef) {

				return event.relatedTarget
					=== comboboxButtonRef.$refs.textInputButton.$refs.iconButton.$el;
			}
		},
		getSearchValueFromValue(value) {

			if (value && value.name && value.name.length)
				return value.name;
			else
				return '';
		},
		setShowDialog(showDialog) {

			if (this.showDialog === true && showDialog === false)
				this.searchValue = this.getSearchValueFromValue(this.value);

			this.showDialog = showDialog;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.details {
	@extend %text-small;
	color: get-color($text, 'muted');
	padding-left: 10px;
}
.item {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
}

.item-main-text {
	height:16px;
	line-height: 16px;
	font-weight: 600;
	overflow: hidden;
	white-space: nowrap;
}

.item-sub-text {
	height:16px;
	font-size: 10px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	overflow: hidden;
	white-space: nowrap;
}
</style>
